export default {
  path: '/oauth',
  name: 'oauth',
  component: () => import('@/views/oauth/index.vue'),
  meta: {
    title: '',
    requiresAuth: false,
  },
  props: (route) => ({ query: route.query }),
};
